<template>
  <navbar-header-component v-if="isUserAuthenticated && (userType == 0 || userType == 1)" />
  <admin-navbar-header-component v-else-if="isUserAuthenticated && (userType == 2 || userType == 3 || userType == 4)" />
  <router-view />
  <footer-component />
</template>

<script>
import { defineComponent, computed } from "vue";
import { useStore } from "vuex";
import "bootstrap/dist/js/bootstrap.min";
import FooterComponent from "@/components/FooterComponent";
import NavbarHeaderComponent from "@/components/NavbarHeaderComponent";
import AdminNavbarHeaderComponent from "@/components/AdminNavbarHeaderComponent";

export default defineComponent({
  components: { NavbarHeaderComponent, AdminNavbarHeaderComponent, FooterComponent },

  setup() {
    const store = useStore();
    const isUserAuthenticated = computed(() => store.getters.isUserAuthenticated);
    const userType = computed(() => store.getters.currentUser.subscriberType);

    return {
      isUserAuthenticated,
      userType
    }
  }
});
</script>

<style>
@import "~bootstrap-icons/font/bootstrap-icons.css";
@import "bootstrap/dist/css/bootstrap.min.css";
</style>
